import { cn } from "@/lib/utils";

import LogoIcon from "@/assets/icons/logo.svg?react";

interface LocationsSectionProps {
  imgSrc: string;
  imagePolygon?: boolean;
}

const LocationsSection = ({ imgSrc, imagePolygon = false }: LocationsSectionProps) => {
  return (
    <div className="sticky top-10 h-fit flex-1 lg:w-[656px]">
      <div className="relative w-full after:absolute after:inset-0 after:rounded-4xl after:content-['']">
        <img
          src={imgSrc}
          alt="hello"
          className={cn(
            "image-cut aspect-square w-full rounded-4xl object-cover",
            imagePolygon ? "image-cut" : "",
          )}
        />
      </div>

      <LogoIcon className="absolute end-6 -top-8 lg:-start-10 lg:top-8" />
    </div>
  );
};

export default LocationsSection;
